import * as React from 'react';

function SvgIconReconciliationReader(props) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M8 0a8 8 0 100 16A8 8 0 008 0z" fill="#F5A623" />
        <path
          d="M8.239 5.5a.77.77 0 00.77-.77v-.46a.77.77 0 00-.77-.77h-.46a.77.77 0 00-.771.77v.46c0 .425.345.77.77.77zm0 7a.77.77 0 00.77-.77V7.27a.77.77 0 00-.77-.77h-.46a.77.77 0 00-.771.77v4.46c0 .425.345.77.77.77z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIconReconciliationReader;
